import { DbIndex, DbTrigger } from "@reporting/rp-types/server";

export type DwhObjectType = 'table' | 'view' | 'procedure' | 'function' | 'index' | 'trigger';

export type DwhObjectNodeProps = {
	type: DwhObjectType;
	object_id?: number;
	schema_name?: string;
	name?: string;
	table_object_id?: number;
	index_id?: number;
	has_primary_key?: boolean;
	indexesCount?: number;
	triggersCount?: number;
	indexes?: DbIndex[];
	triggers?: DbTrigger[];
};

export const buildIndexScriptId = (tableObjectId: number, indexId: number): string =>
	`${tableObjectId}_${indexId}`;

export const READONLY_COLUMNS: string[] = ['IDZ', 'DATE_CREATED', 'WHO_CREATED'];
